(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/admin/react-dialog-wrapper/assets/javascripts/helper.js') >= 0) return;  svs.modules.push('/components/admin/react-dialog-wrapper/assets/javascripts/helper.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var dialog = svs.ui.dialog;

var button = function button(_ref) {
  var title = _ref.title,
    callback = _ref.callback;
  return {
    title: title,
    callback: callback ? callback : function () {}
  };
};
var injectToButtonCallbacks = function injectToButtonCallbacks(buttons, closeDialog) {
  buttons.forEach(function (button) {
    var theCallback = button.callback;
    button.callback = function (dialog, form) {
      closeDialog();
      theCallback(dialog, form);
    };
  });
  return buttons;
};

var checkbox = function checkbox(_ref2) {
  var checked = _ref2.checked,
    text = _ref2.text,
    value = _ref2.value;
  return {
    checked: typeof checked === 'boolean' ? checked : false,
    text: text || '',
    type: dialog.message.CHECKBOX,
    value: typeof value === 'boolean' ? value : false
  };
};

var cmsType = {
  CONFIRM: 'confirm',
  ERROR: 'error',
  INFO: 'info',
  DEFAULT: 'default'
};

var icon = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, cmsType.CONFIRM, 'checkmark'), cmsType.ERROR, 'exclamation-sign'), cmsType.INFO, 'information'), cmsType.DEFAULT, 'information');

var newDialog = function newDialog(_ref3) {
  var area = _ref3.area,
    autoClose = _ref3.autoClose,
    buttons = _ref3.buttons,
    convertToPopup = _ref3.convertToPopup,
    icon = _ref3.icon,
    message = _ref3.message,
    title = _ref3.title,
    type = _ref3.type;
  var theDialog = new dialog.Confirm({
    actions: injectToButtonCallbacks(buttons, function () {
      return theDialog.close();
    }),
    area: area || dialog.area.POPUP,
    autoClose: autoClose || 0,
    branding: "cms dialog-branding-cms-type-".concat(type || 'default'),
    convertToPopup: convertToPopup || false,
    icon: icon,
    message: message || [],
    title: title
  });
  dialog.api.add(theDialog);
  autoClose && setTimeout(function () {
    return theDialog.close();
  }, autoClose);
  if (theDialog.el.parentNode) {
    var outmostElement = theDialog.el.parentNode.parentNode;
    outmostElement.classList.add('dialog-branding-cms-outmost');
    if (area) {
      theDialog.el.classList.add("dialog-branding-cms-".concat(area));
      outmostElement.classList.add("dialog-branding-cms-outmost-area-".concat(area));
    }
  }
  return theDialog;
};

var text = function text(_ref4) {
  var text = _ref4.text;
  return {
    text: text,
    type: dialog.message.TEXT
  };
};

var helper = {
  button: button,
  checkbox: checkbox,
  cmsType: cmsType,
  icon: icon,
  newDialog: newDialog,
  text: text
};
svs.components.dialogWrapper.helper = helper;

 })(window);